/* eslint-disable react/prop-types */
import { Button, Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { ModalCloseBox } from '../../EmployeesStyle';
import { ModalCloseIcon } from '../../../../theme/SvgIcons';
import styled from '@emotion/styled';
import { FieldBox, FlexWrapper } from '../../../../theme/common_style';
import { updatePasswordbyAdmin } from '../../../../redux/employee/apiRoute';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { passwordRules } from '../../../../utils/constant';

const UpdatePassword = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { id } = location.state || {};
  const { isEmployee, data } = useSelector((state) => state?.userInfo) || {};
  const empId = isEmployee ? data?.user_details?.id : id;

  const handleUpdate = async (values) => {
    try {
      setLoading(true);
      const payload = { ...values, employee_id: empId };
      let res = await updatePasswordbyAdmin(payload);
      if (res?.statusCode === 200) {
        toast.success(res?.message || 'Successfully updated');
        onClose();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      prefixCls="create-employees"
      width={376}
      centered
      closeIcon={false}
      footer={null}>
      <ModalCloseBox onClick={onClose}>
        <ModalCloseIcon />
      </ModalCloseBox>
      <ContentBox>
        <h4>Update Password</h4>

        <Form form={form} onFinish={handleUpdate}>
          <FieldBox>
            <label htmlFor="new_password">
              Password <span>*</span>
            </label>
            <Form.Item
              name="new_password"
              rules={[{ required: true, message: 'Password is required' }, ...passwordRules]}
              validateFirst>
              <Input.Password
                prefixCls="form-input"
                placeholder="Enter Password"
                autoComplete="off"
              />
            </Form.Item>
          </FieldBox>
          <FieldBox>
            <label htmlFor="confirm_password">
              Confirm Password <span>*</span>
            </label>
            <Form.Item
              name="confirm_password"
              rules={[
                { required: true, message: 'Confirm Password is required' },
                ...passwordRules
              ]}
              validateFirst>
              <Input.Password
                prefixCls="form-input"
                placeholder="Enter Confirm Password"
                autoComplete="off"
              />
            </Form.Item>
          </FieldBox>
          <FlexWrapper justify="end" style={{ marginTop: 20 }}>
            <Button
              loading={loading}
              onClick={() => form.submit()}
              style={{ width: 140 }}
              prefixCls="antCustomBtn">
              Update
            </Button>
          </FlexWrapper>
        </Form>
      </ContentBox>
    </Modal>
  );
};

export default UpdatePassword;

const ContentBox = styled.div`
  width: 100%;
  padding: 24px;

  h4 {
    font-family: 'Plus Jakarta Sans';
    font-weight: 700;
    font-size: 24px;
    color: #0e0e0e;
    margin: 0;
    text-align: center;
  }
`;
